module.exports = __webpack_public_path__ + "static/media/vf_wskirt_core.0ad87afc.svg";